<script lang="ts" setup>
import BaseIcon from '@/components/ui/BaseIcon/BaseIcon.vue'
import { ToastClose, ToastDescription, ToastProvider, ToastRoot, ToastViewport } from 'reka-ui'
import { useSystemMessageToast } from '@/composables/useSystemMessageToast'
import { formatDate } from '@/utils/formatDateTime'

const { systemMessage, isOpened } = useSystemMessageToast()
</script>
<template>
  <ToastProvider>
    <ToastRoot class="system-toast dropdown-card" :duration="3000" v-model:open="isOpened">
      <div>
        <div class="mb-1 flex gap-2.5">
          <BaseIcon
            v-if="systemMessage.important"
            class="text-warning"
            :icon="'WarningSolidIcon'"
          />
          <ToastDescription as-child>{{ systemMessage.message }}</ToastDescription>
        </div>
        <div class="text-caption text-gray">{{ formatDate(systemMessage.date) }}</div>
      </div>
      <ToastClose
        class="text-black transition-colors hover:text-primary active:text-primary-active"
      >
        <BaseIcon class="w-3.8" icon="CloseIcon" />
      </ToastClose>
    </ToastRoot>
    <ToastViewport
      class="fixed right-3 top-15 z-[2147483647] m-0 flex w-[480px] max-w-[100vw] list-none flex-col items-end gap-[10px] outline-none"
    />
  </ToastProvider>
</template>

<style lang="postcss">
.system-toast {
  @apply flex items-center gap-5 bg-white p-5 text-base;
  @apply data-[state=closed]:animate-hideOut data-[state=open]:animate-slideIn;
}

.system-toast[data-swipe='move'] {
  transform: translateX(var(--reka-toast-swipe-move-x));
}
.system-toast[data-swipe='cancel'] {
  transform: translateX(0);
  transition: transform 200ms ease-out;
}
.system-toast[data-swipe='end'] {
  animation: slideRight 100ms ease-out;
}

@keyframes slideRight {
  from {
    transform: translateX(var(--reka-toast-swipe-end-x));
  }
  to {
    transform: translateX(calc(100% + 40px));
    opacity: 0;
  }
}
</style>
